    angular.module('product')
        .factory('ProductSubstitute', function ($resource) {
            return $resource('/crm/api/product-substitute/:id', {}, {
                list: {method: 'GET', isArray: true}
            });
        })
        .service('ProductSubstituteService', function ($q, $rootScope, toastr, modals, ProductSubstitute) {
            this.importSubstitutes = function () {
                return modals.open('app/product/product-substitute/import-substitutes-modal.html', 'ProductSubstituteImportController', {}, {size: 'md'}, "vm")
            };
            this.findAndChange = function (product, languageCode) {
                var pss = this;
                var defer = $q.defer();
                ProductSubstitute.list({id: product.id}).$promise
                    .then(function (list) {
                        if (list.length > 0) {
                            var produSubsModel = {
                                languageCode: languageCode,
                                product: product,
                                substitutes: list
                            }
                            modals.open('app/product/product-substitute/choose-substitutes-modal.html', 'ProductSubstituteChooseController', produSubsModel, {size: 'md'}, "vm")
                            .then(function (result) {
                                pss.findAndChange(result, languageCode)
                                    .then(function (resultRec) {
                                        defer.resolve(resultRec);
                                    }, function (no) {
                                        defer.resolve(result);
                                    });
                            }, function (cancelled) {
                                defer.reject();
                            });
                        } else {
                            defer.reject();
                        }

                    });
                return defer.promise;
            }
        })
        .controller('ProductSubstituteChooseController', function ($uibModalInstance, data) {
            var vm = this;
            vm.languageCode = data.languageCode;
            vm.product = data.product;
            vm.substitutes = data.substitutes;

            vm.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            vm.pick = function (substitute) {
                $uibModalInstance.close(substitute);
            }
        })
        .controller('ProductSubstituteImportController', function ($cookies, $scope, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
            var vm = this;
            vm.types = ['CSV'];
            vm.import = {
                type: "CSV",
                charset: "CP1250"
            };
            vm.data = [];
            vm.options = {}

            vm.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            vm.uploader = createUploader();

            vm.save = function () {
                var onSaveSuccess = function (result) {
                    toastr.success("Trwa zapisywanie");
                    $uibModalInstance.close(result);
                };

                var onSaveError = function () {
                };
                var params = angular.copy(vm.options);
                params.items = vm.data;
                return $http.post('/crm/api/product-substitute-csv/save-data', params).then(onSaveSuccess, onSaveError);
            };

            function createUploader() {
                var uploader = new FileUploader({
                    url: '/crm/api/product-substitute-csv/read-data',
                    autoUpload: true,
                    headers: {
                        "X-Requested-With": 'XMLHttpRequest',
                        "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                    }
                });
                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    toastr.success("Wczytano dane z pliku");
                    vm.data = response;
                    angular.element("input[type='file']").val(null);
                };
                uploader.onErrorItem = function (fileItem, rejection, status, headers) {
                    if (angular.isArray(rejection.messages)) {
                        angular.forEach(rejection.messages, function (message, key) {
                            toastr.error(message);
                        });
                    }
                };
                uploader.onBeforeUploadItem = function (item) {
                    item.formData.push(vm.import);
                };
                return uploader;
            }
        })
        .directive('productSubstitutes', function ($rootScope, toastr, $filter, $http, ProductSubstitute, modals) {
            return {
                restrict: 'E',
                scope: {
                    productId: '='
                },
                templateUrl: 'app/product/product-substitute/product-substitutes.html',
                link: function (scope, element, attr) {
                    scope.filters = {};
                    reloadList();

                    scope.reloadFiles = function () {
                        reloadList();
                    };

                    scope.clear = function () {
                        scope.filters = {};
                        reloadList();
                    };

                    scope.addSubstitute = function (substitute) {
                        var onSaveSuccess = function (result) {
                            toastr.success("Zapisano rekord: " + result.substitute.symbol);
                            delete scope.substituteToAdd;
                            reloadList();
                        };
                        var onSaveError = function () {
                        };

                        if (substitute.id) {
                            return ProductSubstitute.save({id: scope.productId}, {substituteId: substitute.id}, onSaveSuccess, onSaveError).$promise;
                        }
                    };

                    scope.remove = function (item) {
                        return modals.confirmDelete(item.substitute.symbol, function () {
                            return ProductSubstitute.delete({id: item.id}, function () {
                                scope.substituteList.splice(scope.substituteList.indexOf(item), 1);
                            }).$promise;
                        });
                    };

                    function reloadList() {
                        ProductSubstitute.list({id: scope.productId}, function (response) {
                            scope.substituteList = response;
                        }, function () {
                            scope.substituteList = [];
                        });
                    }

                }
            };
        });
